import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Modal, ModalContent, ModalFooter, ModalTop } from '../../controls/modal/modal';
import { useMessages2 } from '../../hooks/useLanguage';
import { useAppDispatch } from '../../app/hooks';
import { closePopup, showPopup } from '../../app/popup-slice';
import { buttonStyle } from '../../controls/buttons';
import { SaveState } from '../../app/types/api-types';
import { basketActions } from '../../app/basket-slice';
import { urls } from '../../navigation';
import { useURLLang } from '../../app/main-slice';

import styles from './load-previous-config-dialog.module.css';

export function LoadPreviousConfigDialog() {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const langId = useURLLang();
    const { messages } = useMessages2();
    const [ code, setCode ] = useState('');
    const [ lastFailed, setLastFailed ] = useState(false);

    const onLoad = async () => {
        try {
            if(code.toLowerCase().startsWith('sc-')) {
                await dispatch(basketActions.editCartByCode({ cartCode: code }));
                dispatch(showPopup({ dialog: 'baskets' }));
            } else {
                const result = await dispatch(basketActions.editBasketByCode({ code }));
                const savedState = result.payload as SaveState;
                if(savedState.variant) {
                    navigate(urls.variantCfg(langId, savedState.category, savedState.family, savedState.variant));
                } else {
                    navigate(urls.familyCfg(langId, savedState.category, savedState.family));
                }                    
            }
        } catch(err: unknown) {
            setLastFailed(true);
        }
    }

    const onClose = () => {
        dispatch(closePopup())
    }

    const onCodeChange = (v: string) => {
        setCode(v);
        setLastFailed(false);
    }

    const loadDisabled = code.trim() === '';

    return <Modal onClose={onClose}>
        <ModalTop></ModalTop>
        <ModalContent>
            <p>{ messages?.view_previous_configurations_desc ?? '' }</p>
            <input type="text" className={styles.code} value={code} onChange={e => onCodeChange(e.target.value)}/>
            { lastFailed ? 
              <p className={styles.loadError}>{ messages?.previous_load_error ?? '' }</p>
              :
              null
            }
        </ModalContent>
        <ModalFooter>
            <button type="button" className={buttonStyle} onClick={onLoad} disabled={loadDisabled} >{ messages?.view_previous_configurations_load ?? '' }</button>
        </ModalFooter>
    </Modal>

}